export default __webpack_public_path__ + "static/media/iso.8feea986.svg";